import { Box, Container, Stack, Text } from '@chakra-ui/react';

import Image from 'next/image';
import Link from 'next/link';
import type { NextPage } from 'next';
import React from 'react';
import tiramisu from '/public/tiramisu-unsplash.jpg';

const desserts: NextPage = () => {
  return (
    <Container my={8}>
      <Stack>
        <Text>desserts 🍦 are coming sooooon</Text>
        <Link href="/" passHref>
          <Box w="100%">
            <Image
              src={tiramisu}
              alt="Picture of the author"
              quality={30}
              priority
            />
          </Box>
        </Link>
      </Stack>
    </Container>
  );
};

export default desserts;
